export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '经典影片', href: '#cards' },
  { label: '电影专题', href: '#index' },
  { label: '最新动态', href: '#updates' },
  { label: '关于我们', href: '#about' },
  { label: '移动观影', href: '#app' },
];

export const heroData = {
  tag: '经典怀旧 · 高清修复 · 免费在线',
  title: '8090影院 — 重温经典，唤醒8090年代光影记忆',
  slogan: '每一帧都是青春的模样',
  intro: '8090影院是一个专为8090后打造的高清经典怀旧电影库，汇集了1980至1990年代最具代表性的华语影片与海外佳作。无论是港片黄金时代的江湖义气、周星驰的经典喜剧，还是那些年我们追过的文艺爱情，这里都能找到。我们持续修复和更新片源，每天都有新经典入库，无需注册、完全免费，随时随地重温那段属于8090年代的银幕记忆。',
  stats: [
    { value: '2000+', label: '部经典影片' },
    { value: '每日更新', label: '持续扩容片库' },
    { value: '免费在线', label: '无需注册观看' },
  ],
  primaryCta: { label: '开始观影', href: '#cards' },
  secondaryCta: { label: '了解更多', href: '#about' },
  image: 'https://readdy.ai/api/search-image?query=Vintage%20Chinese%20cinema%20atmosphere%20with%20warm%20golden%20film%20projector%20casting%20soft%20light%20across%20a%20nostalgic%20room%2C%20old%20film%20reels%20scattered%20around%2C%20classic%201980s%20and%201990s%20Chinese%20movie%20posters%20on%20aged%20walls%2C%20rich%20amber%20and%20sepia%20tones%2C%20cinematic%20moody%20lighting%20with%20dust%20particles%20floating%20in%20light%20beam%2C%20artistic%20warm%20composition%2C%20high%20detail%20editorial%20photography&width=900&height=675&seq=hero-cinema-2026&orientation=landscape',
};

export const cardsData = [
  {
    id: 1,
    title: '大话西游之大圣娶亲',
    year: '1995',
    genre: '喜剧 / 爱情 / 奇幻',
    director: '刘镇伟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20film%20aesthetic%20with%20warm%20sunset%20tones%2C%20ancient%20Chinese%20architecture%20silhouette%2C%20dramatic%20sky%20with%20golden%20clouds%2C%20cinematic%20atmosphere%2C%20nostalgic%201990s%20Hong%20Kong%20movie%20visual%20style%2C%20soft%20dreamy%20lighting%2C%20romantic%20epic%20feel&width=600&height=400&seq=card-movie-01&orientation=landscape',
    desc: '周星驰经典之作，至尊宝与紫霞仙子的爱情故事，感动了一代人。那句"如果非要在这份爱上加个期限，我希望是一万年"至今仍被传颂。',
  },
  {
    id: 2,
    title: '霸王别姬',
    year: '1993',
    genre: '剧情 / 爱情 / 历史',
    director: '陈凯歌',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20opera%20stage%20with%20dramatic%20theatrical%20lighting%2C%20traditional%20Peking%20opera%20costumes%20in%20rich%20red%20and%20gold%2C%20intense%20emotional%20atmosphere%2C%20classic%20Chinese%20cinema%20aesthetic%2C%20deep%20shadows%20and%20warm%20spotlight%2C%20artistic%20composition%2C%20historical%20drama%20mood&width=600&height=400&seq=card-movie-02&orientation=landscape',
    desc: '张国荣、张丰毅、巩俐联袂出演，跨越半个世纪的悲欢离合，是中国电影史上不可逾越的巅峰之作，荣获戛纳金棕榈奖。',
  },
  {
    id: 3,
    title: '东邪西毒',
    year: '1994',
    genre: '剧情 / 武侠',
    director: '王家卫',
    image: 'https://readdy.ai/api/search-image?query=Desert%20landscape%20with%20solitary%20figure%20in%20traditional%20Chinese%20martial%20arts%20costume%2C%20wind%20sweeping%20sand%2C%20warm%20earthy%20amber%20tones%2C%20cinematic%20widescreen%20composition%2C%20atmospheric%20haze%2C%20poetic%20wuxia%20film%20aesthetic%2C%20melancholy%20mood%2C%20golden%20hour%20lighting&width=600&height=400&seq=card-movie-03&orientation=landscape',
    desc: '王家卫以诗意的镜头语言重新定义武侠，张国荣、梁朝伟等群星演绎沙漠中的爱恨情仇，每一帧都是绝美画面。',
  },
  {
    id: 4,
    title: '甜蜜蜜',
    year: '1996',
    genre: '爱情 / 剧情',
    director: '陈可辛',
    image: 'https://readdy.ai/api/search-image?query=Romantic%201990s%20Hong%20Kong%20street%20scene%20at%20dusk%2C%20neon%20signs%20softly%20glowing%2C%20bicycle%20on%20quiet%20road%2C%20warm%20nostalgic%20tones%2C%20gentle%20evening%20light%2C%20urban%20romance%20atmosphere%2C%20classic%20Chinese%20cinema%20visual%20style%2C%20tender%20mood&width=600&height=400&seq=card-movie-04&orientation=landscape',
    desc: '黎明与张曼玉演绎的经典爱情故事，邓丽君的歌声贯穿全片，讲述两个内地青年在香港的漂泊与相守，温暖而动人。',
  },
  {
    id: 5,
    title: '重庆森林',
    year: '1994',
    genre: '剧情 / 爱情',
    director: '王家卫',
    image: 'https://readdy.ai/api/search-image?query=Moody%20neon%20lit%20urban%20street%20at%20night%20with%20light%20rain%2C%20convenience%20store%20glow%2C%20colorful%20reflections%20on%20wet%20pavement%2C%20cinematic%20Hong%20Kong%20aesthetic%2C%20dreamy%20bokeh%20lights%2C%20lonely%20urban%20romance%20vibe%2C%20art%20house%20film%20style%2C%20green%20and%20gold%20tone&width=600&height=400&seq=card-movie-05&orientation=landscape',
    desc: '王家卫镜头下的香港都市爱情，林青霞、金城武、梁朝伟、王菲四人交错的情感故事，独特的手持摄影风格令人着迷。',
  },
];

export const rankingData = [
  { rank: 1, title: '大话西游之大圣娶亲', year: '1995', hot: 9856, trend: 'up' },
  { rank: 2, title: '无间道', year: '2002', hot: 9234, trend: 'up' },
  { rank: 3, title: '霸王别姬', year: '1993', hot: 8976, trend: 'stable' },
  { rank: 4, title: '喜剧之王', year: '1999', hot: 8654, trend: 'up' },
  { rank: 5, title: '倩女幽魂', year: '1987', hot: 8321, trend: 'down' },
  { rank: 6, title: '英雄本色', year: '1986', hot: 7987, trend: 'up' },
];

export const indexData = [
  { id: 1, title: '香港经典', desc: '港片黄金年代', count: 328, icon: 'ri-building-2-line' },
  { id: 2, title: '武侠江湖', desc: '刀光剑影恩仇录', count: 156, icon: 'ri-sword-line' },
  { id: 3, title: '喜剧之王', desc: '笑中带泪的年代', count: 203, icon: 'ri-emotion-laugh-line' },
  { id: 4, title: '文艺时光', desc: '诗意与光影交织', count: 142, icon: 'ri-quill-pen-line' },
  { id: 5, title: '警匪风云', desc: '正邪较量经典', count: 187, icon: 'ri-police-car-line' },
  { id: 6, title: '爱情物语', desc: '那些年的心动', count: 168, icon: 'ri-heart-line' },
  { id: 7, title: '恐怖惊魂', desc: '胆量与回忆齐飞', count: 94, icon: 'ri-ghost-line' },
  { id: 8, title: '动画回忆', desc: '童年经典再现', count: 112, icon: 'ri-movie-line' },
  { id: 9, title: '海外经典', desc: '世界影史佳作', count: 245, icon: 'ri-global-line' },
];

export const updatesData = [
  { id: 1, date: '2026-07-30', title: '《青蛇》4K修复版正式上线', tag: '新片入库', desc: '徐克经典奇幻作品，张曼玉、王祖贤绝美演绎白蛇与青蛇，全新4K修复画质重温经典。' },
  { id: 2, date: '2026-07-28', title: '周星驰喜剧专题周启动', tag: '专题活动', desc: '本周集中推荐星爷十部经典喜剧，从《赌圣》到《少林足球》，笑点密集不间断。' },
  { id: 3, date: '2026-07-25', title: '王家卫作品全集整理上线', tag: '合集更新', desc: '《阿飞正传》《花样年华》《2046》等王家卫导演全系列作品已整理完毕，一站式重温。' },
  { id: 4, date: '2026-07-22', title: '张国荣纪念影展专区开放', tag: '纪念专题', desc: '致敬永远的哥哥，精选《倩女幽魂》《阿飞正传》《春光乍泄》等代表作限时展映。' },
  { id: 5, date: '2026-07-20', title: '港产警匪片高清片源扩充', tag: '片源更新', desc: '新增《喋血双雄》《枪火》《暗战》等经典警匪片高清版本，画质大幅提升。' },
  { id: 6, date: '2026-07-18', title: '8090动画经典专区全新上线', tag: '新区开放', desc: '《大闹天宫》《哪吒闹海》《天书奇谭》等国产动画经典已入驻新专区。' },
  { id: 7, date: '2026-07-15', title: '林正英僵尸片全集修复完毕', tag: '经典修复', desc: '《僵尸先生》《一眉道人》等林正英僵尸喜剧系列已全部完成高清修复。' },
  { id: 8, date: '2026-07-12', title: '刘德华从影40年作品回顾', tag: '影人专题', desc: '从《天若有情》到《无间道》，回顾华仔四十载银幕经典角色与蜕变。' },
  { id: 9, date: '2026-07-10', title: '暑期学生免费观影活动开启', tag: '福利活动', desc: '暑假期间学生用户可免费观看全部影片，不限次数，让经典陪伴你的假期时光。' },
];

export const topicsData = [
  { id: 1, name: '周星驰', count: 42, icon: 'ri-star-line' },
  { id: 2, name: '张国荣', count: 35, icon: 'ri-heart-line' },
  { id: 3, name: '王家卫', count: 28, icon: 'ri-camera-line' },
  { id: 4, name: '港片经典', count: 156, icon: 'ri-building-line' },
  { id: 5, name: '武侠情怀', count: 89, icon: 'ri-sword-line' },
  { id: 6, name: '爱情文艺', count: 73, icon: 'ri-heart-2-line' },
  { id: 7, name: '警匪动作', count: 94, icon: 'ri-shield-flash-line' },
  { id: 8, name: '喜剧搞笑', count: 118, icon: 'ri-emotion-happy-line' },
  { id: 9, name: '恐怖惊悚', count: 47, icon: 'ri-ghost-smile-line' },
  { id: 10, name: '经典动画', count: 56, icon: 'ri-movie-2-line' },
  { id: 11, name: '好莱坞经典', count: 132, icon: 'ri-earth-line' },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-database-2-line',
    title: '海量经典片库',
    desc: '收录超过2000部8090年代经典影片，涵盖港片、国产、海外佳作，持续更新扩容中。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '高清修复画质',
    desc: '多数影片经过专业高清修复处理，告别模糊画质，在大屏幕上重温经典更加赏心悦目。',
  },
  {
    id: 3,
    icon: 'ri-riding-line',
    title: '流畅不缓冲',
    desc: '全球多节点CDN加速，无需漫长等待缓冲，点击即可流畅播放，享受丝滑观影体验。',
  },
  {
    id: 4,
    icon: 'ri-refresh-line',
    title: '每日持续更新',
    desc: '团队每日维护片库，不断修复、上新经典影片，让怀旧之旅永不停歇。',
  },
  {
    id: 5,
    icon: 'ri-device-line',
    title: '多端随心看',
    desc: '支持电脑、平板、手机多设备无缝切换，在家用大屏、出门用手机，经典随时在线。',
  },
];

export const aboutData = {
  title: '关于8090影院',
  desc1: '8090影院诞生于对经典电影的无限热爱。我们是一群在8090年代长大的影迷，那些年租碟片、追港片、挤录像厅的日子是我们共同的记忆。我们深知，经典不会褪色，只是需要一个好的平台让它们重新发光。',
  desc2: '我们致力于打造国内最全、最高清的怀旧电影库，从片源收集、画质修复到精心分类，每一步都用心打磨。无论你是想重温周星驰的喜剧，感受王家卫的文艺，还是回味港产警匪片的紧张刺激，8090影院都是你最温暖的港湾。',
  image: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20home%20cinema%20room%20with%20vintage%20movie%20posters%20on%20wall%2C%20cozy%20amber%20lighting%2C%20old%20film%20camera%20on%20wooden%20shelf%2C%20retro%20style%20room%20with%20film%20reels%20decoration%2C%20comfortable%20viewing%20space%2C%20golden%20hour%20sunlight%20through%20window%2C%20warm%20sepia%20tones%2C%20cinematic%20atmosphere&width=700&height=500&seq=about-cinema-2026&orientation=landscape',
};

export const carouselData = [
  {
    id: 1,
    title: '港片黄金年代：1980-1997',
    desc: '从《英雄本色》到《无间道》，香港电影最辉煌的十七年，无数经典在此诞生。小马哥、陈家驹、至尊宝……每一个名字都是一段青春。',
    image: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20cityscape%20at%20night%20with%20vintage%20neon%20signs%20from%201980s%2C%20classic%20cinema%20marquee%20with%20Chinese%20characters%2C%20warm%20golden%20and%20red%20tones%2C%20cinematic%20atmosphere%2C%20nostalgic%20urban%20scene%2C%20film%20noir%20lighting%2C%20busy%20street%20with%20old%20taxis&width=800&height=450&seq=carousel-hk-cinema&orientation=landscape',
  },
  {
    id: 2,
    title: '武侠世界：江湖儿女情长',
    desc: '从金庸古龙的快意恩仇到徐克的视觉奇观，武侠电影承载了8090后对江湖的全部想象。一剑一酒一匹马，便是整个天下。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20martial%20arts%20scene%20in%20misty%20bamboo%20forest%2C%20silhouette%20of%20swordsman%20in%20flowing%20robe%2C%20golden%20sunlight%20breaking%20through%20fog%2C%20cinematic%20widescreen%20composition%2C%20atmospheric%20and%20poetic%2C%20warm%20earthy%20tones%2C%20classic%20wuxia%20film%20aesthetic&width=800&height=450&seq=carousel-wuxia&orientation=landscape',
  },
  {
    id: 3,
    title: '喜剧之王：周星驰的电影人生',
    desc: '从《赌圣》到《功夫》，星爷用无厘头喜剧诠释小人物的喜怒哀乐。那些看似荒诞的笑料背后，藏着最真实的人间悲欢。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20Chinese%20comedy%20film%20set%20with%20colorful%20retro%20props%2C%20warm%20stage%20lights%2C%20playful%20atmosphere%2C%201990s%20Hong%20Kong%20movie%20studio%20aesthetic%2C%20golden%20and%20red%20decorations%2C%20cinematic%20lighting%2C%20nostalgic%20entertainment%20vibe&width=800&height=450&seq=carousel-comedy&orientation=landscape',
  },
  {
    id: 4,
    title: '文艺时光：那些触动心灵的光影',
    desc: '王家卫的迷离、杨德昌的克制、侯孝贤的长镜头……华语文艺片用独特的东方美学，讲述了一个个关于时间、记忆与爱的故事。',
    image: 'https://readdy.ai/api/search-image?query=Art%20house%20cinema%20interior%20with%20warm%20dim%20lighting%2C%20red%20velvet%20seats%2C%20vintage%20film%20projector%20beam%2C%20nostalgic%20atmosphere%2C%20empty%20theater%20with%20screen%20glowing%20softly%2C%20cinematic%20mood%2C%20golden%20and%20burgundy%20tones%2C%20quiet%20contemplative%20space&width=800&height=450&seq=carousel-arthouse&orientation=landscape',
  },
];

export const mediaData = [
  {
    id: 1,
    title: '《大话西游》经典片段：一万年',
    duration: '03:25',
    desc: '至尊宝对紫霞说出那段经典台词，感动亿万观众。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20film%20romantic%20scene%20with%20warm%20sunset%20light%2C%20video%20player%20interface%20overlay%2C%20ancient%20Chinese%20costume%20drama%20aesthetic%2C%20golden%20hour%20glow%2C%20cinematic%20atmosphere%2C%20nostalgic%20movie%20moment&width=640&height=360&seq=media-preview-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《英雄本色》小马哥经典枪战',
    duration: '05:12',
    desc: '周润发饰演的小马哥，风衣墨镜双枪，定义了港片英雄。',
    image: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20action%20film%20scene%20with%20dramatic%20lighting%2C%20trench%20coat%20figure%20in%20shadow%2C%20urban%20night%20setting%2C%20cinematic%20noir%20style%2C%20warm%20golden%20and%20dark%20tones%2C%20classic%20gangster%20movie%20aesthetic&width=640&height=360&seq=media-preview-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《倩女幽魂》宁采臣夜遇聂小倩',
    duration: '04:38',
    desc: '张国荣与王祖贤的银幕经典相遇，凄美动人。',
    image: 'https://readdy.ai/api/search-image?query=Misty%20ancient%20Chinese%20temple%20at%20night%20with%20moonlight%2C%20ethereal%20atmosphere%2C%20floating%20white%20silk%20fabric%2C%20ghost%20story%20aesthetic%2C%20cool%20blue%20and%20silver%20tones%20with%20warm%20lantern%20light%2C%20cinematic%20fantasy%20scene&width=640&height=360&seq=media-preview-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《无间道》天台对决',
    duration: '04:55',
    desc: '梁朝伟与刘德华的经典天台对峙，"我想做个好人"。',
    image: 'https://readdy.ai/api/search-image?query=Rooftop%20scene%20at%20dusk%20with%20two%20figures%20facing%20each%20other%2C%20city%20skyline%20background%2C%20dramatic%20golden%20hour%20lighting%2C%20cinematic%20tension%2C%20Hong%20Kong%20urban%20landscape%2C%20warm%20amber%20sky%2C%20film%20noir%20composition&width=640&height=360&seq=media-preview-04&orientation=landscape',
  },
];

export const commentsData = [
  {
    id: 1,
    name: '老电影爱好者阿强',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20middle%20aged%20Chinese%20man%20smiling%20in%20cozy%20home%20environment%2C%20soft%20natural%20lighting%2C%20friendly%20expression%2C%20simple%20warm%20background%2C%20approachable%20and%20genuine&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    date: '2026-07-29',
    content: '终于找到组织了！小时候跟爸爸一起看周星驰，现在自己重温还是笑得不行。画质比小时候看的录像带清晰太多了，修复效果真的很惊艳。每天下班回来看一部，感觉又回到了那个单纯的年代。',
  },
  {
    id: 2,
    name: '港片铁粉小雯',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20Chinese%20woman%20in%20her%2030s%20with%20gentle%20smile%2C%20soft%20indoor%20lighting%2C%20cozy%20atmosphere%2C%20natural%20look%2C%20simple%20warm%20background&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    date: '2026-07-26',
    content: '王家卫的片子每部都看了至少三遍，每次看都有不同感受。《重庆森林》里金城武吃罐头的场景，以前觉得好笑，现在看却莫名感伤。感谢这个平台把这些珍贵的电影保存得这么好。',
  },
  {
    id: 3,
    name: '90后怀旧青年大林',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20young%20Chinese%20man%20in%20casual%20setting%2C%20warm%20lighting%2C%20genuine%20smile%2C%20simple%20background%2C%20natural%20and%20approachable&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    date: '2026-07-23',
    content: '虽然是90后，但林正英的僵尸片、成龙的动作片都是童年回忆啊。周末约了几个朋友来家里，用投影仪放《英雄本色》，大家都看嗨了。片库很全，分类也很清晰，找片特别方便。',
  },
  {
    id: 4,
    name: '资深影迷猫姐',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20Chinese%20woman%20with%20confident%20smile%2C%20soft%20natural%20light%2C%20cozy%20home%20setting%2C%20friendly%20and%20genuine%20expression%2C%20simple%20warm%20background&width=80&height=80&seq=avatar-user-04&orientation=squarish',
    date: '2026-07-20',
    content: '《霸王别姬》在这里重温已经是第五遍了，每次都哭得稀里哗啦。希望平台能继续更新更多经典，特别是那些比较冷门但质量很高的文艺片。我会一直支持下去！',
  },
];

export const faqData = [
  {
    id: 1,
    question: '8090影院需要注册付费吗？',
    answer: '完全不需要。8090影院秉持免费分享经典的理念，所有影片均可免费在线观看，无需注册账号，无需支付任何费用。我们通过广告维持运营，不影响您的观影体验。',
  },
  {
    id: 2,
    question: '影片画质如何？支持高清播放吗？',
    answer: '大部分影片均提供高清乃至超清版本，我们团队持续对经典老片进行数字修复，尽量还原最佳画质。部分影片支持1080P甚至4K分辨率，让您在重温经典时拥有更好的视觉体验。',
  },
  {
    id: 3,
    question: '可以在手机或平板上观看吗？',
    answer: '当然可以。8090影院已全面适配移动端，无论是iOS还是Android设备，手机还是平板，打开浏览器即可流畅观看，无需下载任何APP。也支持投屏到电视，与家人共享经典时光。',
  },
  {
    id: 4,
    question: '片库多久更新一次？有哪些类型的电影？',
    answer: '我们保持每日更新的节奏，不断扩充片库。影片类型覆盖港片经典、国产佳作、武侠动作、喜剧搞笑、爱情文艺、警匪犯罪、恐怖惊悚、动画动漫以及海外经典等多个类别，满足不同口味。',
  },
  {
    id: 5,
    question: '遇到播放问题或想推荐影片怎么办？',
    answer: '您可以通过页面底部的联系方式给我们留言，反馈播放问题或推荐您想看的经典影片。我们非常重视每一位用户的建议，会尽快处理您的问题并考虑您的推荐。',
  },
];

export const contactData = {
  title: '联系我们',
  desc: '如果您在观影过程中遇到任何问题，或者想推荐您心目中的经典影片，欢迎通过以下方式联系我们。我们珍视每一位8090影迷的声音。',
  email: 'feedback@8090cinema.com',
  wechat: '8090cinema',
  qq: '8090cinema',
};

export const appData = {
  title: '随时随地重温经典',
  desc: '无需下载APP，手机浏览器直接访问8090影院，流畅观影体验不打折。支持添加到手机桌面，一键直达，让经典电影随时随地陪伴你。',
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20showing%20classic%20Chinese%20movie%20streaming%20interface%20on%20screen%2C%20warm%20cinematic%20lighting%2C%20phone%20placed%20on%20wooden%20table%20with%20coffee%20cup%20nearby%2C%20cozy%20home%20environment%2C%20amber%20and%20gold%20tones%2C%20modern%20mobile%20streaming%20concept&width=500&height=600&seq=app-mobile-2026&orientation=portrait',
};

export const footerData = {
  siteName: '8090影院',
  slogan: '重温经典，唤醒8090年代光影记忆。每一帧都是青春的模样。',
  copyright: '© 2026 8090影院. 本站所有内容仅供学习和交流，请于下载后24小时内删除。',
};